import * as React from 'react';
import { useSelector } from 'react-redux';

import { getDeviceType, getCategory, getChartsData, getChartsLoading } from '../../selectors';
import { ChartFactory } from './ChartFactory';
import { EChartType } from '../../types/charts';
import { getLabelText } from './utils/getLabelText';
import { getDealTypeForChart } from './utils/getDealTypeForChart';
import { useIsMobile, useIsNotDesktop } from '../../components/Responsive';
import { EBlockInPageName } from '../../types/share';
import { useOnHover } from './utils/useOnHover';
import { useOnSwipe } from './utils/useOnSwipe';

export function ChartOffersViewedContainer() {
  const chartData = useSelector(getChartsData('demand'));
  const isMobile = useIsMobile();
  const isNotDesktop = useIsNotDesktop();
  const isLoading = useSelector(getChartsLoading);
  const category = useSelector(getCategory);
  const chartDealType = getDealTypeForChart(category);
  const firstLabel = isMobile ? '' : getLabelText(chartDealType, EChartType.OffersViewed);
  const deviceType = useSelector(getDeviceType);

  const onHover = useOnHover(EBlockInPageName.Demand, isNotDesktop);
  const onSwipe = useOnSwipe(EBlockInPageName.Demand);

  if (chartData && chartData.chart) {
    return (
      <ChartFactory
        loading={isLoading}
        chartData={chartData.chart}
        deviceType={deviceType}
        dealType={chartDealType}
        firstLabel={firstLabel}
        chartType={EChartType.OffersViewed}
        onSwipe={onSwipe}
        onHover={onHover}
      />
    );
  }

  return null;
}
